import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type ModalSize = "sm" | "md" | "lg" | "xl";

const SIZE_CLASSES: Record<ModalSize, string> = {
  sm: "max-w-[400px] max-h-[90vh] overflow-y-auto",
  md: "max-w-[80vw] xl:max-w-[500px] max-h-[90vh] overflow-y-auto",
  lg: "max-w-[90vw] xl:max-w-[1000px] max-h-[90vh] overflow-y-auto",
  xl: "max-w-[90vw] xl:max-w-[1600px] max-h-[90vh] overflow-y-auto",
};

type ModalProps = {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  dismissible?: boolean;
  size?: ModalSize;
  contentClassName?: string;
};

export const Modal = ({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  dismissible = true,
  size = "md",
  contentClassName,
}: ModalProps) => (
  <Dialog
    open={open}
    onOpenChange={(v) => {
      if (!v && dismissible) onClose();
    }}
  >
    <DialogContent
      className={cn("overflow-y-auto", SIZE_CLASSES[size], contentClassName)}
      showClose={dismissible}
      onEscapeKeyDown={(e) => {
        if (!dismissible) e.preventDefault();
      }}
      onPointerDownOutside={(e) => {
        if (!dismissible) e.preventDefault();
      }}
      {...(description ? {} : { "aria-describedby": undefined })}
    >
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      {children}
      {footer && <DialogFooter>{footer}</DialogFooter>}
    </DialogContent>
  </Dialog>
);
